import { AppContext } from "@/App.context";
import config from "@/config";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { DownloadFile } from "@/lib/download-file";

// ------------------------------api for the individual vertical bar graph details download in all cloud recommendation-------------------------------------------------------------
export const getIndividualAllCloudDownload = (token) => {
  return async (
    {
      service,
      page,
      resourceType,
      recordsPerPage,
      idleDays,
      desc,
      orderBy,
      filters,
      untagged,
      tableName,
      status,
    },
    signal
  ) => {
    const url = new URL(
      `${config.apiHost}/v1/${service}/recommendations/download`
    );

    if (untagged) {
      url.searchParams.append("untagged", "true");
    }

    const owners = await fetch(url.toString(), {
      method: "POST",
      body: JSON.stringify(),
      signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!owners.ok) {
      throw new Error((await owners.json()).message);
    }

    const reader = owners.body.getReader();
    const stream = new ReadableStream({
      start(controller) {
        function push() {
          reader.read().then(({ done, value }) => {
            if (done) {
              controller.close();
              return;
            }
            controller.enqueue(value);
            push();
          });
        }
        push();
      },
    });
    const blob = await new Response(stream).blob();
    const fileName = `recommendation-individual-data.csv`;
    DownloadFile(blob, fileName);
  };
};

/**

 * @param {GetStatisticsReq} req
 * @param {any[]=} deps
 */
export const UseIndividualAllCloudDownload = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const mutation = useMutation({
    mutationKey: ["getIndividualAllCloudDownload", req, ...deps],
    mutationFn: ({ signal }) =>
      getIndividualAllCloudDownload(appContext.idToken)(req, signal),
  });
  return mutation;
};
